import React from "react";
import ReactDOM from "react-dom";
import "./assets/vendors/style";
import "./styles/app.scss";
import App from "./App";
import { BrowserRouter,HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { onLodingSignIn } from "./redux/actions/authActions";
import {
  MuiPickersUtilsProvider,
  
} from '@material-ui/pickers';
import frLocale from "date-fns/locale/fr";
import PickerDateFns from '@date-io/date-fns';
import { SnackbarProvider } from 'notistack';

store.dispatch(onLodingSignIn());

ReactDOM.render(
  <Provider store={store}>
  <HashRouter>
   <MuiPickersUtilsProvider utils={PickerDateFns} locale={frLocale}>
   <SnackbarProvider>
      <App />
    </SnackbarProvider>
   </MuiPickersUtilsProvider>
   </HashRouter>
   </Provider>
  ,

  document.getElementById("root")
);
